module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/resonio/load_data_en-16d38d0b3aa5030f4af8976feba89844.gif";